'use client'

import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import Text from '../../Text'
import PricingOffer from './PricingOffer'
import { useRegionCoachingOffers } from '../../RegionSurfaces'
import { CircularProgress, Grow } from '@mui/material'

function PricingTableCoaching({ textColor, cta, bottomText }) {
  // Runtime CMS-driven colour -> inline style (matches former styled `${props.color}`).
  const colorStyle = { color: textColor.value }

  // Overmind→server-props (Phase A2.2): coaching offers come from the SSR-threaded
  // <RegionSurfacesProvider> (byte-identical to the store, which stays hydrated),
  // with an Overmind fallback for any non-page entry point.
  const { coachingOffers, ensureRequested } = useRegionCoachingOffers()

  useEffect(() => {
    ensureRequested()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // #418: gate the loader on THIS section's OWN data (vrsCoachingOffers), NOT the
  // global state.isLoading flag. It is SSR-hydrated whenever the page renders this
  // section (buildSurfaceMutations), so it is PRESENT on the client's first render
  // — SSR and client-first render content identically. The loader shows only when
  // the data is genuinely absent (SAME on both sides). The old `state.isLoading`
  // gate emitted a spinner into the SSR HTML whenever any OTHER section's fetch
  // flipped the global flag (the latency-only #418 cascade).
  if (!coachingOffers || !coachingOffers.length) {
    return (
      <div className={styles.loading} style={colorStyle}>
        <CircularProgress color="inherit"/>
      </div>
    )
  }

  return (
    <div style={colorStyle}>
      <div className={styles.contentWrapper}>
        <div className={styles.pricingOffersWrapper}>
          { coachingOffers.map((s, i) =>
            <PricingOffer
              key={s.code}
              show={true}
              title={s.name}
              subtitle={s.description}
              isMostPopular={i === 1}
              price={s.price}
              features={s.features}
              cta={cta}
            /> )
          }
        </div>
        {bottomText && <Text type="body-short-2">{bottomText}</Text>}
      </div>
    </div>
  )
}

export default PricingTableCoaching
